import { render, staticRenderFns } from "./TasksHive.vue?vue&type=template&id=9e57a8b0&scoped=true&"
import script from "./TasksHive.vue?vue&type=script&lang=js&"
export * from "./TasksHive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e57a8b0",
  null
  
)

export default component.exports